/* eslint-disable no-unused-vars */
import { $http } from '@/utils/http'
import host from '@/utils/host'
import queryString from 'query-string'
import { report } from '@/utils/reportError'
import { hasNeedLoginKeyWords } from '@/utils/handleError'
import moment from 'moment'

export default {
  namespaced: true,
  state: {
    noticeList: [],
    remind: {},
    expiresTime: '' // 过期时间
  },
  mutations: {
    setNoticeList(state, list) {
      state.noticeList = list
    },
    setRemind(state, data) {
      state.remind = {...state.remind, ...data}
    },
    setMutation(state, { data, namespace }) {
      state[namespace] = data
    },
    setExpiresTime(state, data) {
      state.expiresTime = data
  }
  },
  actions: {
    async getKeyExpiresTime({ commit }, params) {
      const res = await $http.get(`${host.portal}/portal-api/user/getAppkeyExpiresTime.do`)
      commit('setExpiresTime', res.data.expiresTime ? (moment().unix() >  res.data.expiresTime ? 'AppKey已过期，请及时更新' :`AppKey有效期至:${moment(res.data.expiresTime).format('YYYY.MM.DD')}` ): '' )
      return res
  },
    async getNoticeList({ commit }) {
      // deprecated // TODO: remove
      const url = `${host.scm}/partners-scm-web/notice/getNoticeList.do`
      const res = await $http.get(url)
      if (res) {
        commit('setNoticeList', res.list || [])
        return res.list || []
      } else if (hasNeedLoginKeyWords(res)) {
        report({
          url,
          res,
          msg: '去登陆'
        })
      } else {
        !res.report && report({
          url,
          res,
          msg: res.msg || '协同工作台获取资讯服务接口异常'
        })
        return []
      }
    },
    // 待办事项
    async getTodo({ commit }) {
      // deprecated // TODO: remove
      const url = `${host.scm}/partners-scm-web/index/querySum.do`
      const res = await $http.get(url)
      if (res) {
        if (typeof(res) === 'string') {
          try {
            const dd = JSON.parse(res)
            if (dd.code * 1 === 1) {
              commit('setRemind', dd.data || {})
            } else {
              !res.report && report({
                url,
                res,
                msg: res.msg || '协同工作台获取待办事项接口异常'
              })
            }
          } catch (e) {
            console.log(e)
            if (hasNeedLoginKeyWords(res)) {
              return report({
                url,
                res,
                msg: '去登陆'
              })
            }
            !res.report && report({
              url,
              res,
              msg: res.msg || '协同工作台获取待办事项接口异常, JSON.parse'
            })
          }
        }
        // return {}
      } else {
        !res.report && report({
          url,
          res,
          msg: res.msg || '协同工作台获取待办事项接口异常'
        })
        // return {}
      }
    },
    async getAnalyseData({ commit }, param) {
      // deprecated // TODO: remove
      const url = `${host.scm}/partners-scm-web/index/getAnalyseDayData.do`
      const res = await $http.post(url, queryString.stringify({ ...param }), {
        headers: {
          'content-Type': 'application/x-www-form-urlencoded'
        }
      })
      if (res && res instanceof Array) {
        return res
      } else if (hasNeedLoginKeyWords(res)) {
        return report({
          url,
          res,
          msg: '去登陆'
        })
      } else {
        !res.report && report({
          url,
          params: queryString.stringify({ ...param }),
          res,
          msg: res.msg || '协同工作台获取近况趋势信息接口异常'
        })
        return []
      }
    },
    // 运营状况
    async getTradeInfo({commit}) {
      // deprecated // TODO: remove
      const url = `${host.scm}/partners-scm-web/index/getOperateData.do?channelId=0`
      const res = await $http.get(url)
      if (res) {
        return res
      } else if (hasNeedLoginKeyWords(res)) {
        return report({
          url,
          res,
          msg: '去登陆'
        })
      } else {
        !res.report && report({
          url,
          res,
          msg: res.msg || '协同工作台获取近运营状况接口异常'
        })
        return {}
      }
    },
    async getCategoryQQ() {
      const url = `${host.scm}/partners-scm-web/index/getCategoryQQ.do`
      const res = await $http.get(url)
      if (res && res instanceof Array) {
        return res
      } else if (hasNeedLoginKeyWords(res)) {
        return report({
          url,
          res,
          msg: '去登陆'
        })
      } else {
        !res.report && report({
          url,
          res,
          msg: res.msg || '协同工作台获取财务QQ接口异常'
        })
        return []
      }
    },
    async queryPartnerBusinessInfo() {
      const url = `${host.hbpsproxyapi}/hbp-sproxy-api/kwbsapi/o/business/querySupplierBusinessInfoForWorkbench.do`
      return await $http.get(url)
    },
    async queryHomeCoreData() {
      let queryTime = moment().format('YYYY-MM-DD')
      let reduTime = moment().subtract(1, 'days').format('YYYY-MM-DD')
      const url = `${host.dataadvice}/k-dataadvice/advice/homeCoreData.do?dateType=day&queryTime=${queryTime}&reduTime=${reduTime}`
      return await $http.get(url)
    },
    async queryHomeTopTen() {
      const url = `${host.dataadvice}/k-dataadvice/advice/homeTopTen.do`
      return await $http.get(url)
    }
  }
}
